import React from "react";
import FileItem from "./fileItem";
import FolderItem from "./folderItem";


// factory abstract build design  
export default class DirectoryItem extends React.Component {

    render() {
        const { item } = this.props;
        const rename = this.props.renameItem === item?._id;
        // let { view } = this.props;
        // console.log(this.props)

        // view = (view === 'row' || view === "square" || view === undefined) ? "normal" : "detail";
        // console.log('itemslsl', item)
        switch (item?.type) {
            case "folder":
                {
                    return (
                        <FolderItem
                            name={item.name}
                            rename={rename}
                            onRenameItem={this.props.onRenameItem}
                            view={this.props.view}
                        // item={this.props.item}
                        // onContextMenu={this.props.onContextMenu}
                        // view={view}
                        // onRightClick={(event) => this.props.onRightClickItem(event, item, "folder")}
                        // onClick={this.props.onClickItem}
                        // onMoveToTrash={this.props.onMoveToTrash}
                        // showPaste={this.props.showPaste}

                        />
                    )
                }
            case 'file':
                {
                    return (
                        <FileItem
                            item={item}
                            name={item.orgName ?? item.name}
                            rename={rename}
                            onRenameItem={this.props.onRenameItem}
                            view={this.props.view}
                        // currentItem={this.props.currentItem}
                        // paths={this.props.paths}
                        // onContextMenu={this.props.onContextMenu}
                        // onClick={this.props.onClickItem}
                        // onRightClick={(event) => this.props.onRightClickItem(event, item, "file")}
                        // onMoveToTrash={this.props.onMoveToTrash}
                        />
                    )
                }
            default:
                // console.error(`<invalid directory item type> type ${this.props.item.type}`)
                return null;
        }


    }



}